__turbopack_context__.v({
  "animTextContent": "t6bP-G_animTextContent",
  "desktopBr": "t6bP-G_desktopBr",
  "root": "t6bP-G_root",
  "stickyWrapper": "t6bP-G_stickyWrapper",
  "tc1": "t6bP-G_tc1",
  "tc2": "t6bP-G_tc2",
});
